import React from "react";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NotFoundScreen = () => {
  return (
    <div className="not-authenticated-screen">
      <FontAwesomeIcon icon={faExclamationTriangle} className="icon" />
      <div>Sorry, it seems page does not exist.</div>
    </div>
  )
}

export default NotFoundScreen;
